import { sha256 } from '@noble/hashes/sha2.js';
import { ctr } from '@noble/ciphers/aes.js';

export default async function encrypt(text) {
  const password = 'bl1tz4r1';
  const enc = new TextEncoder();

  // SHA-256 hash of password — same as crypto.subtle.digest('SHA-256', ...)
  const key = sha256(enc.encode(password));

  // crypto.getRandomValues is available even in non-secure contexts (HTTP on LAN)
  const iv = crypto.getRandomValues(new Uint8Array(16));

  // AES-CTR encrypt — output is byte-compatible with Web Crypto for any password length
  const stream = ctr(key, iv);
  const encrypted = stream.encrypt(enc.encode(text));

  // Same output format: ivHex:dataHex
  const ivHex = Array.from(iv)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  const dataHex = Array.from(encrypted)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return ivHex + ':' + dataHex;
}
